// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./styleguide/styleguide.scss
 ** module id = 8
 ** module chunks = 1
 **/